import orderFiles from '4-order-detail-cards/attachments/_index.js'
import textareaCounter from '4-component/textarea-counter/_index.js'
import chat from '4-order-detail-cards/chat/_index.js'
import {openDownloadLink, downloadSelected, deleteSelected} from 'utils/_download.js'
import { convertDateManual, convertDateAuto, convertDateObject } from 'utils/_convert_date.js'
import {loadingWindowHidden, loadingWindowVisible, loadingWindowHandler} from "4-component/loading/_index";
import dayjs from "dayjs";
import ajaxRequest from 'utils/_ajax-request.js'
//import ajaxOpenButton from 'utils/_ajax-open-button.js'
//import accountOrderDetail from '3-section/section-account-order-detail/_index.js'
import runGallery from 'utils/_run_gallery.js'
//import notificationBell from 'utils/_notification_bell.js'
import {changePriorityWindowToggle, changePriorityInit} from '4-component/change-priority/_index.js'
import updateOrderListFrontend from 'utils/_update-account-order-list.js'

/**
 * @param {Event} event
 */
let onToggleHistoryStatusOrder = (event) => {
  event.preventDefault()
  const historyBlockElement = document.getElementById('order-status-history-block')
  if (!historyBlockElement) {
    return
  }
  historyBlockElement.classList.toggle('visible')
}


/**
 * @param {Function} callback
 * @param {int|string} orderId
 */
let transferToOrder = (callback, orderId) =>
  () => {
    let url = '/{!_locale}/account/orders/{!id}/transfer-to-order'
      .replaceAll('{!_locale}', (document.documentElement.lang || 'en'))
      .replaceAll('{!id}', orderId)
    let formData = new FormData

    const priorityElement = document.getElementById('order_change_priority_select')
    if( priorityElement ) {
      formData.append('priority', priorityElement.value);
    }

    const materialElement = document.getElementById('order_new_form_material')
    if( materialElement ) {
      formData.append('material', materialElement.value);
    }

    const fileFormatElement = document.getElementById('order_new_form_file_format')
    if( fileFormatElement ) {
      formData.append('file_format', fileFormatElement.value);
    }

    const commentElement = document.getElementById('order_new_form_comment')
    if( commentElement ) {
      formData.append('comment', commentElement.value);
    }

    changePriorityWindowToggle('hide')

    loadingWindowVisible('process', '#page-ajax')
    ajaxRequest(callback, url, formData, 'POST')
  }



let afterUpdateOrder = () =>
  /**
   * @param {XMLHttpRequest} xhr
   * @param {boolean} error
   */
    (xhr, error) => {
    if( error ) {
      loadingWindowHidden('process', '#page-ajax')
      loadingWindowVisible('error', '#page-ajax')
      return false
    }

    loadingWindowHidden('process', '#page-ajax')
    loadingWindowVisible('success', '#page-ajax')

    updateOrderList()

    let newData = JSON.parse(xhr.responseText)

    document.querySelector('.order-detail-cards__to-order').classList.remove('visible')

    if( newData.hasOwnProperty('newStatus') && newData['newStatus'] ) {
      const historyTable = document.querySelector('.order-detail-cards__order-details-history-table tbody')
      var tr = document.createElement('tr');
      var td1 = document.createElement('td');
      var td2 = document.createElement('td');
      var td3 = document.createElement('td');
      var text1 = document.createTextNode(newData['newStatus']['user']);
      var text2 = document.createTextNode( dayjs(new Date(parseInt(newData['newStatus']['date'], 10) * 1000)).format('YYYY-MM-DD HH:mm:ss') );
      var text3 = document.createTextNode(newData['newStatus']['status']);
      td1.appendChild(text1);
      td2.appendChild(text2);
      td3.appendChild(text3);
      tr.appendChild(td1);
      tr.appendChild(td2);
      tr.appendChild(td3);
      historyTable.appendChild(tr);

      if( document.getElementById('order_status_readonly') ) {
        document.getElementById('order_status_readonly').innerText = newData['newStatus']['status']
      }
    }

    const priorityText = document.getElementById('order_detail_priority')
    if( priorityText ) {
      priorityText.innerText = newData['newPriority']
    }

    const materialText = document.getElementById('order_detail_material')
    if( materialText ) {
      materialText.innerText = newData['newMaterial']
    }

    const fileFormatText = document.getElementById('order_detail_file_format')
    if( fileFormatText ) {
      fileFormatText.innerText = newData['newFileFormat']
    }

    const commentText = document.querySelector('.order-detail-cards__comments-text')
    if( commentText ) {
      commentText.innerHTML = newData['newComment']
    }
  }


let updateOrderList = () => {
  let searchParams = new URLSearchParams(window.location.search);
  if( searchParams.has('order_id') ) {
    searchParams.delete('order_id')
  }
  if( searchParams.has('user_id') ) {
    searchParams.delete('user_id')
  }

  let url = '/{!_locale}/account/orders/list-ajax' + '?' + searchParams.toString()
  url = url.replaceAll('{!_locale}', (document.documentElement.lang || 'en'))

  ajaxRequest(afterUpdateOrderList, url, {}, 'GET')
}


let afterUpdateOrderList = (xhr, error) => {
  if( error ) {
    return false
  }
  let data = JSON.parse(xhr.responseText)
  updateOrderListFrontend(data)
}


/*let afterUpdateOrderList = (xhr, error) => {
  if( error ) {
    return false
  }

  let data = JSON.parse(xhr.responseText)

  const tbody = document.querySelector('.order-list__body')
  tbody.innerHTML = data['tbody']

  const totalItems = document.querySelector('.order-list__total-value span')
  if( totalItems ) {
    totalItems.innerHTML = data['pagination']['totalItems']
  }

  const totalPages = document.querySelectorAll('.pagination__all-pages')
  totalPages.forEach((element) => {
    element.innerHTML = '/' + data['pagination']['totalPages']
  })

  const pageBack = document.querySelectorAll('.pagination__pages-arrow_back')
  pageBack.forEach((element) => {
    element.setAttribute('data-page', data['pagination']['prev'])
    if( data['pagination']['prevHide'] ) {
      element.classList.add('pagination__pages-arrow_hidden');
    }
    else {
      element.classList.remove('pagination__pages-arrow_hidden');
    }
  })

  const pageForward = document.querySelectorAll('.pagination__pages-arrow_forward')
  pageForward.forEach((element) => {
    element.setAttribute('data-page', data['pagination']['next'])
    if( data['pagination']['nextHide'] ) {
      element.classList.add('pagination__pages-arrow_hidden');
    }
    else {
      element.classList.remove('pagination__pages-arrow_hidden');
    }
  })

  document.querySelectorAll('.order-list__open').forEach((e) => {ajaxOpenButton(
    e,
    '.order-list__body-item',
    '/{!_locale}/account/orders/{!id}',
    accountOrderDetail(
      '#order-status-history-link',
      '#order-status-history-close'
    )
  )})

  notificationBell()
}*/



/**
 * @param {string} historyLinkId
 * @param {string} historyCloseId
 */
export default (historyLinkId, historyCloseId) => () => {
  let orderId = document.querySelector('.section-account-order-detail').dataset.orderId


  /*if( document.querySelector('.order-detail-cards__to-order-change-btn') ) {
    document.querySelector('.order-detail-cards__to-order-change-btn').addEventListener('click', transferToOrder(afterUpdateOrder(), orderId))
  }*/

  const transferOrderBtn = document.querySelector('.order-detail-cards__to-order-change-btn')
  if( transferOrderBtn ) {
    transferOrderBtn.addEventListener('click', ()=>{
      changePriorityWindowToggle('show')
    })

    const changePriorityBtnYes = document.getElementById('change-priority-user-button-yes')
    if( changePriorityBtnYes ) {
      changePriorityBtnYes.addEventListener('click', transferToOrder(afterUpdateOrder(), orderId))
    }

    changePriorityInit()
  }



  loadingWindowHandler('#page-ajax')


  //document.getElementsByTagName('textarea').forEach((e) => {textareaCounter(e)})

  document.querySelector(historyLinkId).addEventListener('click', onToggleHistoryStatusOrder)
  document.querySelector(historyCloseId).addEventListener('click', onToggleHistoryStatusOrder)

  orderFiles(
    orderId,
    'order_attachments',
    'order_attachments_input',
    '--attachments',
  )
  orderFiles(
    orderId,
    'order_result_files',
    'order_result_files_input',
    '--result-files',
  )
  chat(
    orderId,
    false,
    '/account/messages/add',
  )

  let urlDownloadAll = window.location.protocol + "//" + window.location.host + "" + '/{!_locale}/account/orders/{!id}/download-all/'
    .replaceAll('{!_locale}', (document.documentElement.lang || 'en'))
    .replaceAll('{!id}', orderId)

  let urlDownloadSelected = window.location.protocol + "//" + window.location.host + "" + '/{!_locale}/account/orders/{!id}/download-selected/'
    .replaceAll('{!_locale}', (document.documentElement.lang || 'en'))
    .replaceAll('{!id}', orderId)

  const containerResultFiles = document.querySelector('.--result-files');
  /*containerResultFiles.querySelector('.order-detail-cards__attachments-all-link').addEventListener('click', () => {
    if( containerResultFiles.querySelectorAll('.dz-image-preview').length ) {
      openDownloadLink(urlDownloadAll, 'result')
    }
  })*/

  containerResultFiles.querySelector('.order-detail-cards__attachments-all-icon').addEventListener('click', (event) => {
    event.preventDefault()
    downloadSelected(containerResultFiles, urlDownloadSelected, 'result')
  })


  const containerAttachmentsFiles = document.querySelector('.--attachments');
  /*containerAttachmentsFiles.querySelector('.order-detail-cards__attachments-all-link').addEventListener('click', () => {
    if( containerAttachmentsFiles.querySelectorAll('.dz-image-preview').length ) {
      openDownloadLink(urlDownloadAll, 'attachments')
    }
  })*/

  containerAttachmentsFiles.querySelector('.order-detail-cards__attachments-all-icon').addEventListener('click', (event) => {
    event.preventDefault()
    downloadSelected(containerAttachmentsFiles, urlDownloadSelected, 'attachments')
  })

  const bubble = document.querySelector('.order-notification__item[data-order="'+orderId+'"]')
  if( bubble ) {
    bubble.remove()
  }

  const themeAccount = document.querySelector('.order-list__body-item[data-id="'+orderId+'"] .order-list__value-notification')
  if( themeAccount ) {
    themeAccount.classList.remove('order-list__value-notification--alert')
  }

  convertDateAuto()

  if( window.innerWidth < 768 ) {
    const cardTitles = document.querySelectorAll('.section-account-order-detail__card-title')
    if( cardTitles.length ) {
      cardTitles.forEach((element) => {
        element.addEventListener('click', (event) => {
          event.preventDefault()
          event.target.nextElementSibling.classList.toggle('hidden')
          event.target.classList.toggle('active')
        })
      })
    }

    const cardTitles2 = document.querySelectorAll('.section-admin-order-detail__card-title')
    if( cardTitles2.length ) {
      cardTitles2.forEach((element) => {
        element.addEventListener('click', (event) => {
          event.preventDefault()
          event.target.nextElementSibling.classList.toggle('hidden')
          event.target.classList.toggle('active')
        })
      })
    }
  }

  runGallery()
}
